import { useCallback, useEffect, useMemo, useState } from "react";
import { Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import useLanguage from "../../hooks/useLanguage";
import useContent from "../../hooks/useContent";
import useToaster from "../../hooks/useToaster";
import CommonPage from "../../components/common-page";
import PlayerSkeleton from "./skeleton";
import { BodyWrapper, StyledVideo, VideoWrapper } from "./style";

export default function Player() {
  const [
    {
      pages: { player: text },
    },
  ] = useLanguage();
  const { getContentById } = useContent();
  const { addToaster } = useToaster();
  const [title, setTitle] = useState("");
  const [videoUrl, setVideoUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  const contentId = useMemo(() => window.location.pathname.split("/")[2], []);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        setLoading(true);
        const response = await getContentById(contentId);
        setTitle(response.title || "");
        setVideoUrl(response.metadata?.banner || null);
      } catch (err) {
        addToaster({ message: text.error, severity: "error" });
      } finally {
        setLoading(false);
      }
    };

    if (contentId) fetchContent();
    else setLoading(false);
  }, []);

  const handleOpenEditor = useCallback(() => {
    if (!contentId) return;
    window.history.pushState({}, "", `/reframe-editor/${contentId}`);
    window.dispatchEvent(new PopStateEvent("popstate"));
  }, [contentId]);

  if (loading) return <PlayerSkeleton />;

  return (
    <CommonPage
      title={title || text.title}
      subtitle={text.subtitle}
      action={
        contentId
          ? { label: text.editor, icon: <EditIcon />, onClick: handleOpenEditor }
          : undefined
      }
    >
      <BodyWrapper>
        <VideoWrapper>
          {videoUrl ? (
            <StyledVideo src={videoUrl} controls autoPlay />
          ) : (
            <Typography variant="body2" color="text.secondary">
              {text.notFound}
            </Typography>
          )}
        </VideoWrapper>
      </BodyWrapper>
    </CommonPage>
  );
}
